module.exports = __webpack_public_path__ + "static/mg-b0b36c1d259ec96e0a75846b0721bb0e.png";